import { render, staticRenderFns } from "./CodeLogin.vue?vue&type=template&id=047e5896&scoped=true"
import script from "./CodeLogin.vue?vue&type=script&lang=js"
export * from "./CodeLogin.vue?vue&type=script&lang=js"
import style0 from "./CodeLogin.vue?vue&type=style&index=0&id=047e5896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e5896",
  null
  
)

export default component.exports